var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiResetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiResetIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.854.036a.25.25 0 0 0-.272.053l-1.521 1.505A5.937 5.937 0 0 0 6 0a6 6 0 1 0 4.8 9.6 1 1 0 0 0-1.6-1.2A4 4 0 1 1 6 2a3.954 3.954 0 0 1 2.636 1L6.941 4.681a.251.251 0 0 0 .02.373c.037.029.082.047.129.052l4.64.514h.028a.248.248 0 0 0 .25-.25V.267a.251.251 0 0 0-.154-.231Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiResetIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgHaidiResetIcon;